<!--Header-->
<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
    <h4 class="modal-title w-100">{{x_titulo}}</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
      <span aria-hidden="true" class="white-text">&times;</span>
    </button>
</div>

<!--Body-->
<div class="modal-body">
  <mdb-card>
        <mdb-card-header>Datos de la Plantilla</mdb-card-header>
        <mdb-card-body>
            <div class="form-row mb-3" *ngIf="false">
                <div class="col-3">Código:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="20"  class="form-control" [(ngModel)]="id" placeholder="" readonly>
                </div>
            </div>
            <div class="form-row mb-3">
              <div class="col-3">Nombre de la Plantilla:</div>
              <div class="col-9">
                <input mdbInput type="text" maxlength="1000"  class="form-control" [(ngModel)]="maePlantillaE.x_nombre" placeholder="">
              </div>
            </div>
            <div class="form-row mb-3">
                <div class="col-3">Descripcion:</div>
                <div class="col-9">
                  <textarea mdbInput type="text" rows="3" maxlength="2000"  class="form-control" [(ngModel)]="maePlantillaE.x_descripcion" placeholder=""></textarea>
                </div>
            </div>
            <div class="form-row mb-3">
              <div class="col-3">Archivo:</div>
              <div class="col-9">

              <div *ngIf="seactualiza" class="custom-file">
                  <input type="file" class="custom-file-input" multiple id="importFile" (change)="onFileChange($event.target.files)">
                  <label class="custom-file-label" #labelArchivo for="importFile">Seleccionar archivo</label>
              </div>
              <div *ngIf="esupdate" class="input-group-append">
                <button *ngIf="seactualiza==false" mdbBtn type="button" (click)="onDescargarArchivo()" size="sm" class="btn btn-blue btn-rounded " mdbWavesEffect>
                  <mdb-icon fas icon="download" class="mr-1"></mdb-icon>Descargar</button>
                <button *ngIf="seactualiza==false" mdbBtn type="button" (click)="onMostrarActualizar(true)" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
                  <mdb-icon fas icon="sync" class="mr-1"></mdb-icon>Actualizar</button>
                <button *ngIf="seactualiza" mdbBtn type="button" (click)="onMostrarActualizar(false)" size="sm" class="px-3 btn btn-blue btn-rounded" mdbWavesEffect>
                  <mdb-icon fas icon="window-close" class="mr-1"></mdb-icon>Cancelar</button>
              </div>
              </div>
            </div>
          <div class="form-row mb-3">
            <div class="col-3">Estado:</div>
            <div class="col-9">
              <select class="browser-default custom-select" [(ngModel)]="maePlantillaE.c_estado">
                <option value="0" selected>Seleccione</option>
                <option *ngFor="let listEstado of listEstado" [value]="listEstado.c_tabla">{{listEstado.x_valor}}</option>
              </select>
            </div>
          </div>
        </mdb-card-body>
  </mdb-card>
  <br>
  <div class="justify-content-center" style="text-align: center;">
    <button mdbBtn type="button" (click)="onGrabar()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
        <mdb-icon fas icon="save" class="mr-1"></mdb-icon>Grabar</button>
  </div>
  <!--Footer-->

